import React from 'react';
import Navbar from './Navbar';
import { Grid2, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

export default function Shopkeeper_Block_List() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [fetchShopData, setFetchShopData] = React.useState([]);

  // Fetch the shopkeeper list data
  const fetchShopkeeperLists = () => {
    const token = localStorage.getItem('accessToken');
    // fetch(`https://api.adoop.in/api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop/2b35f4f1-4c30-4544-945b-21810834910e`, {
      fetch(`https://api.adoop.in/api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setFetchShopData(data);  // Update the state with the fetched data
      })
      .catch((error) => console.error(error));
  };

  // Call the function to fetch data on component mount
  React.useEffect(() => {
    fetchShopkeeperLists();
  }, []);

  // Handle page change
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // Reset page to the first page when rows per page changes
  };

  // Slice the data for the current page
  const currentData = fetchShopData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <div>
      <Navbar />
      <br />
      <Typography variant="h4" gutterBottom>
        Shopkeeper List
      </Typography>
      <br />
      <Grid2 container>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 940 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Mobile Number</TableCell>
                  <TableCell>StateName</TableCell>
                  <TableCell>CityName</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell> {/* Adjust index based on the page */}
                    <TableCell>{data.name}</TableCell>
                    <TableCell>{data.address}</TableCell> {/* Assuming 'address' field exists */}
                    <TableCell>{data.user_info.mobile}</TableCell>
                    <TableCell>{data.stateName}</TableCell>
                    <TableCell>{data.cityName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={fetchShopData.length}  
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Grid2>
    </div>
  );
}
